import { render, staticRenderFns } from "./PackageIn.vue?vue&type=template&id=46fd5df9&scoped=true"
import script from "./PackageIn.vue?vue&type=script&lang=js"
export * from "./PackageIn.vue?vue&type=script&lang=js"
import style0 from "./PackageIn.vue?vue&type=style&index=0&id=46fd5df9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fd5df9",
  null
  
)

export default component.exports